<div class="addressForm-container" [style.padding-bottom]="editSelectedAddress  ? '140px' : '90px'" [style.padding-top]="isHome ? '60px': '0px'">
  <app-mobile-header [title]="!editSelectedAddress ? 'add.new.address' : 'edit.saved.address'" [manualBackEvent]="true"
    (onManualBackEvent)="backPreviousPage()"></app-mobile-header>

  <form focusInvalidInput [formGroup]="addressForm" (ngSubmit)="onSubmit()" class="addressForm">
    <app-address-search (outputSelectedAddress)="selectAddress($event)" [searchValue]="this.searchValue"
      [isAddNewAddress]="isAddNewAddress">
    </app-address-search>

    <div class="input-outline">
      <span class="p-float-label">
        <input id="address-name" class="inputFielsTruncateText" type="text" maxlength="100" pInputText formControlName="addressDesc" #addressNamevalue
          appInputTrim>
        <label for="address-name">{{'label.name.and.label' | translate}}</label>
      </span>
      <i class="icon-times" *ngIf="addressNamevalue.value" (click)="addressNamevalue.value = ''"></i>
    </div>

    <div class="addressLabel-container">
      <input class="label_radio" id="label_one" name="addressIcon" type="radio" [value]="addressType.home"
        formControlName="addressIcon">
      <label class="label_option_container" id="one-label" for="label_one">
        <i class="icon-home"></i>
        <span>{{'label.home' | translate}}</span>
      </label>

      <input class="label_radio" id="label_two" name="addressIcon" type="radio" [value]="addressType.work"
        formControlName="addressIcon">
      <label class="label_option_container" id="two-label" for="label_two">
        <i class="icon-work"></i>
        <span>{{'label.work' | translate}}</span>
      </label>

      <input class="label_radio" id="label_three" name="addressIcon" type="radio" [value]="addressType.other"
        formControlName="addressIcon">
      <label class="label_option_container" id="three-label" for="label_three">
        <i class="icon-rate-star"></i>
        <span>{{'label.other' | translate}}</span>
      </label>
    </div>

    <div class="input-outline">
      <span class="p-float-label">
        <input id="unitNo" type="text" maxlength="50" pInputText formControlName="unitNo" appInputTrim #addressUnitvalue>
        <label for="unitNo">{{'label.floor.unit' | translate}} <span *ngIf="!addressUnitvalue.value" class="optional-label">({{'label.optional' | translate}})</span></label>
      </span>
      <i class="icon-times" *ngIf="addressUnitvalue.value" (click)="addressUnitvalue.value = ''"></i>
    </div>

    <div class="noteToDriver-container">
      <div class="input-outline">
        <span class="p-float-label">
          <textarea id="remarks" rows="2" cols="30" maxlength="254" pInputTextarea formControlName="remarks"
            appInputTrim #remarksValue></textarea>
          <label for="remarks">{{'label.note.to.driver' | translate}} <span *ngIf="!remarksValue.value" class="optional-label">({{'label.optional' | translate}})</span></label>
        </span>
      </div>
    </div>

    <div class="defaultFlag-container">
      <span>{{'label.set.as.default.address' | translate}}</span>
      <p-inputSwitch formControlName="defaultFlag" />
    </div>
  </form>

  <app-button [blackTextButton]="true" [buttonName]="'button.delete.address'" class="deleteAddress-btn"
    (onClickEvent)="onClickDelete()" *ngIf="editSelectedAddress"></app-button>

  <app-bottom-action-footer [buttonName]="!editSelectedAddress ? ('button.save'): ('button.update')"
    [disbaleButton]="!addressForm.valid" (onClickEvent)="onSubmit()"></app-bottom-action-footer>
</div>
